export const nameValidityRegex = /^[ 0-9a-zA-Z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F.'’()/-]*$/;

export const checkNameValidity = (name: string) => {
    const normalizedName = name.normalize('NFC');
    const invalidCharacters = new Set();

    for (const char of normalizedName) {
        const valid = nameValidityRegex.test(char);

        if (!valid) {
            invalidCharacters.add(char);
        }
    }

    return {
        isValid: invalidCharacters.size === 0,
        invalidCharacters: Array.from(invalidCharacters),
    };
};
